// Mapeo de emojis a palabras clave para búsqueda (español e inglés)
export const emojiKeywords: Record<string, string[]> = {
  // Sonrisas y personas
  '😀': ['sonrisa', 'feliz', 'contento', 'alegre', 'smile', 'happy', 'grin'],
  '😃': ['sonrisa', 'feliz', 'alegre', 'cara', 'smile', 'happy', 'face', 'smiley'],
  '😄': ['sonrisa', 'feliz', 'risa', 'dientes', 'smile', 'happy', 'laugh', 'teeth'],
  '😁': ['sonrisa', 'dientes', 'feliz', 'smile', 'teeth', 'happy', 'grin'],
  '😆': ['risa', 'feliz', 'carcajada', 'laugh', 'happy', 'laughing'],
  '😅': ['risa', 'sudor', 'nervioso', 'laugh', 'sweat', 'nervous'],
  '🤣': ['risa', 'carcajada', 'lol', 'laugh', 'rolling', 'rofl'],
  '🙂': ['sonrisa', 'feliz', 'suave', 'smile', 'happy', 'slight'],
  '🙃': ['sonrisa', 'alreves', 'sarcastico', 'smile', 'upside', 'down', 'sarcastic'],
  '😉': ['guiño', 'picaro', 'complicidad', 'wink', 'flirt'],
  '😊': ['sonrisa', 'feliz', 'timido', 'ruborizado', 'smile', 'happy', 'blush', 'shy'],
  '😇': ['angel', 'inocente', 'bueno', 'angel', 'innocent', 'good', 'halo'],
  '🥰': ['amor', 'enamorado', 'corazones', 'love', 'hearts', 'crush'],
  '😍': ['amor', 'enamorado', 'corazones', 'ojos', 'love', 'hearts', 'eyes'],
  '🤩': ['estrella', 'ojos', 'impresionado', 'wow', 'star', 'eyes', 'impressed', 'starstruck'],
  '😘': ['beso', 'amor', 'corazon', 'kiss', 'love', 'heart'],
  '😎': ['lentes', 'cool', 'genial', 'sol', 'sunglasses', 'cool', 'awesome'],
  '🤔': ['pensar', 'duda', 'hmm', 'think', 'thinking', 'doubt', 'hmm'],
  '😐': ['neutral', 'serio', 'inexpresivo', 'neutral', 'serious', 'expressionless'],
  '😑': ['aburrido', 'inexpresivo', 'bored', 'expressionless'],
  '😏': ['picaro', 'sarcastico', 'smirk', 'sarcastic'],
  '🙄': ['ojos', 'exasperado', 'eyes', 'roll', 'exasperated'],
  '😢': ['triste', 'llorar', 'lagrima', 'sad', 'cry', 'tear'],
  '😭': ['llorar', 'triste', 'lagrimas', 'cry', 'sad', 'tears', 'sobbing'],
  '😱': ['asustado', 'sorprendido', 'miedo', 'scared', 'surprised', 'fear', 'scream'],
  '😴': ['dormir', 'sueño', 'cansado', 'sleep', 'tired', 'sleeping'],
  '🤐': ['silencio', 'callado', 'zipper', 'silence', 'quiet', 'zip'],
  '🤨': ['ceja', 'duda', 'sospecha', 'eyebrow', 'doubt', 'suspect', 'raised'],
  '🥵': ['calor', 'sudor', 'hot', 'heat', 'sweat'],
  '🥶': ['frio', 'congelado', 'cold', 'frozen', 'freezing'],
  '🤯': ['mente', 'explosion', 'shock', 'mind', 'blown', 'exploding'],
  '🤠': ['vaquero', 'cowboy', 'sombrero', 'cowboy', 'hat'],
  '🥳': ['fiesta', 'celebrar', 'cumpleaños', 'party', 'celebrate', 'birthday'],
  '🤓': ['nerd', 'lentes', 'inteligente', 'nerd', 'glasses', 'smart', 'geek'],

  // Animales
  '🐕': ['perro', 'mascota', 'animal', 'dog', 'pet', 'animal'],
  '🐶': ['perro', 'cachorro', 'mascota', 'dog', 'puppy', 'pet', 'face'],
  '🐱': ['gato', 'mascota', 'animal', 'cat', 'pet', 'animal', 'face'],
  '🐈': ['gato', 'mascota', 'cat', 'pet'],
  '🦁': ['leon', 'animal', 'salvaje', 'lion', 'animal', 'wild'],
  '🐯': ['tigre', 'animal', 'salvaje', 'tiger', 'animal', 'wild', 'face'],
  '🐘': ['elefante', 'animal', 'grande', 'elephant', 'animal', 'big'],
  '🐵': ['mono', 'animal', 'monkey', 'animal', 'face'],
  '🐼': ['panda', 'oso', 'animal', 'panda', 'bear', 'animal'],
  '🐧': ['pinguino', 'ave', 'animal', 'penguin', 'bird', 'animal'],
  '🦉': ['buho', 'ave', 'nocturno', 'owl', 'bird', 'night'],
  '🐸': ['rana', 'sapo', 'anfibio', 'frog', 'toad', 'amphibian'],
  '🐢': ['tortuga', 'lento', 'animal', 'turtle', 'slow', 'animal'],
  '🦋': ['mariposa', 'insecto', 'butterfly', 'insect'],
  '🐝': ['abeja', 'insecto', 'bee', 'insect'],

  // Comida
  '🍕': ['pizza', 'comida', 'italiana', 'pizza', 'food', 'italian'],
  '🍔': ['hamburguesa', 'comida', 'fast', 'burger', 'hamburger', 'food', 'fast'],
  '🍟': ['papas', 'fritas', 'comida', 'fries', 'french', 'food'],
  '🌭': ['hot', 'dog', 'perro', 'caliente', 'hot', 'dog', 'food'],
  '🍿': ['palomitas', 'cine', 'maiz', 'popcorn', 'movies', 'corn'],
  '🍎': ['manzana', 'fruta', 'roja', 'apple', 'fruit', 'red'],
  '🍌': ['banana', 'platano', 'fruta', 'banana', 'fruit'],
  '🍇': ['uvas', 'fruta', 'grapes', 'fruit'],
  '🍓': ['fresa', 'fruta', 'roja', 'strawberry', 'fruit', 'red'],
  '🍉': ['sandia', 'fruta', 'verano', 'watermelon', 'fruit', 'summer'],
  '🍊': ['naranja', 'fruta', 'citrico', 'orange', 'fruit', 'citrus'],
  '🍋': ['limon', 'fruta', 'citrico', 'amarillo', 'lemon', 'fruit', 'citrus', 'yellow'],
  '🥑': ['aguacate', 'palta', 'verde', 'avocado', 'green'],
  '🍅': ['tomate', 'rojo', 'vegetal', 'tomato', 'red', 'vegetable'],
  '🥕': ['zanahoria', 'vegetal', 'naranja', 'carrot', 'vegetable', 'orange'],
  '🌮': ['taco', 'comida', 'mexicana', 'taco', 'food', 'mexican'],
  '🌯': ['burrito', 'comida', 'mexicana', 'burrito', 'food', 'mexican'],
  '🍣': ['sushi', 'comida', 'japonesa', 'sushi', 'food', 'japanese'],
  '🍜': ['ramen', 'sopa', 'comida', 'japonesa', 'ramen', 'soup', 'food', 'japanese', 'noodles'],
  '🍰': ['pastel', 'postre', 'dulce', 'cake', 'dessert', 'sweet'],
  '🎂': ['pastel', 'cumpleaños', 'torta', 'cake', 'birthday'],
  '🍪': ['galleta', 'dulce', 'cookie', 'cookie', 'sweet'],
  '🍩': ['dona', 'donut', 'dulce', 'donut', 'doughnut', 'sweet'],
  '🍫': ['chocolate', 'dulce', 'chocolate', 'sweet'],
  '🍦': ['helado', 'postre', 'frio', 'ice', 'cream', 'dessert', 'cold'],
  '☕': ['cafe', 'bebida', 'caliente', 'coffee', 'drink', 'hot'],
  '🍺': ['cerveza', 'bebida', 'alcohol', 'beer', 'drink', 'alcohol'],
  '🍷': ['vino', 'bebida', 'alcohol', 'wine', 'drink', 'alcohol'],

  // Deportes
  '⚽': ['futbol', 'pelota', 'deporte', 'soccer', 'football', 'ball', 'sport'],
  '🏀': ['basketball', 'basquet', 'pelota', 'basketball', 'ball', 'sport'],
  '🏈': ['futbol', 'americano', 'deporte', 'football', 'american', 'sport'],
  '⚾': ['baseball', 'beisbol', 'pelota', 'baseball', 'ball', 'sport'],
  '🎾': ['tenis', 'pelota', 'deporte', 'tennis', 'ball', 'sport'],
  '🏐': ['voleibol', 'voley', 'pelota', 'volleyball', 'ball', 'sport'],
  '🏓': ['ping', 'pong', 'tenis', 'mesa', 'ping', 'pong', 'tennis', 'table'],
  '🏆': ['trofeo', 'premio', 'campeon', 'trophy', 'award', 'champion', 'winner'],
  '🥇': ['medalla', 'oro', 'primero', 'medal', 'gold', 'first'],
  '🥈': ['medalla', 'plata', 'segundo', 'medal', 'silver', 'second'],
  '🥉': ['medalla', 'bronce', 'tercero', 'medal', 'bronze', 'third'],

  // Viajes
  '🚗': ['carro', 'auto', 'vehiculo', 'car', 'auto', 'vehicle'],
  '🚕': ['taxi', 'carro', 'taxi', 'cab', 'car'],
  '🚙': ['camioneta', 'suv', 'vehiculo', 'suv', 'truck', 'vehicle'],
  '🚌': ['autobus', 'bus', 'transporte', 'bus', 'transport'],
  '✈️': ['avion', 'vuelo', 'viaje', 'airplane', 'plane', 'flight', 'travel'],
  '🚀': ['cohete', 'espacio', 'nasa', 'rocket', 'space', 'nasa'],
  '🚁': ['helicoptero', 'vuelo', 'helicopter', 'flight'],
  '🚲': ['bicicleta', 'bici', 'transporte', 'bicycle', 'bike', 'transport'],
  '🏍️': ['moto', 'motocicleta', 'motorcycle', 'bike'],
  '🚂': ['tren', 'transporte', 'train', 'transport'],
  '⛵': ['barco', 'velero', 'mar', 'boat', 'sailboat', 'sea'],
  '🏠': ['casa', 'hogar', 'edificio', 'house', 'home', 'building'],
  '🏢': ['edificio', 'oficina', 'trabajo', 'building', 'office', 'work'],
  '🏨': ['hotel', 'alojamiento', 'hotel', 'accommodation'],
  '🏖️': ['playa', 'vacaciones', 'arena', 'beach', 'vacation', 'sand'],
  '⛰️': ['montaña', 'naturaleza', 'mountain', 'nature'],

  // Objetos
  '💡': ['bombilla', 'luz', 'idea', 'bulb', 'light', 'idea'],
  '🔑': ['llave', 'candado', 'puerta', 'key', 'lock', 'door'],
  '📱': ['telefono', 'celular', 'movil', 'phone', 'mobile', 'cell'],
  '💻': ['computadora', 'laptop', 'pc', 'computer', 'laptop', 'pc'],
  '⌨️': ['teclado', 'escribir', 'keyboard', 'type'],
  '🖱️': ['mouse', 'raton', 'mouse'],
  '📷': ['camara', 'foto', 'camera', 'photo'],
  '📺': ['television', 'tv', 'television', 'tv'],
  '⏰': ['reloj', 'alarma', 'despertador', 'clock', 'alarm', 'time'],
  '📚': ['libros', 'estudiar', 'leer', 'books', 'study', 'read'],
  '✏️': ['lapiz', 'escribir', 'pencil', 'write'],
  '📝': ['nota', 'escribir', 'documento', 'note', 'write', 'document', 'memo'],
  '📧': ['email', 'correo', 'mensaje', 'email', 'mail', 'message'],
  '💰': ['dinero', 'plata', 'rico', 'money', 'cash', 'rich'],
  '💳': ['tarjeta', 'credito', 'pago', 'card', 'credit', 'payment'],
  '🎁': ['regalo', 'presente', 'cumpleaños', 'gift', 'present', 'birthday'],
  '🎈': ['globo', 'fiesta', 'cumpleaños', 'balloon', 'party', 'birthday'],
  '🎉': ['celebracion', 'fiesta', 'confeti', 'celebration', 'party', 'confetti'],
  '🔥': ['fuego', 'caliente', 'genial', 'fire', 'hot', 'awesome', 'lit'],

  // Símbolos
  '❤️': ['corazon', 'amor', 'rojo'],
  '💙': ['corazon', 'azul', 'amor'],
  '💚': ['corazon', 'verde', 'amor'],
  '💛': ['corazon', 'amarillo', 'amor'],
  '💜': ['corazon', 'morado', 'amor'],
  '🖤': ['corazon', 'negro', 'amor'],
  '🤍': ['corazon', 'blanco', 'amor'],
  '💔': ['corazon', 'roto', 'triste'],
  '⭐': ['estrella', 'favorito'],
  '✨': ['brillar', 'estrella', 'magico'],
  '💫': ['mareo', 'estrella'],
  '⚡': ['rayo', 'electrico', 'rapido'],
  '🔴': ['circulo', 'rojo'],
  '🟢': ['circulo', 'verde'],
  '🔵': ['circulo', 'azul'],
  '🟡': ['circulo', 'amarillo'],
  '✅': ['check', 'correcto', 'si', 'hecho'],
  '❌': ['x', 'error', 'no', 'incorrecto'],
  '⚠️': ['advertencia', 'precaucion', 'cuidado'],
  '🚫': ['prohibido', 'no', 'stop'],
  '💯': ['cien', '100', 'perfecto'],
  '🔞': ['adultos', '18', 'prohibido'],

  // Banderas
  '🇲🇽': ['mexico', 'bandera'],
  '🇺🇸': ['usa', 'estados', 'unidos', 'bandera'],
  '🇪🇸': ['españa', 'spanish', 'bandera'],
  '🇦🇷': ['argentina', 'bandera'],
  '🇧🇷': ['brasil', 'brazil', 'bandera'],
  '🇨🇱': ['chile', 'bandera'],
  '🇨🇴': ['colombia', 'bandera'],
  '🇵🇪': ['peru', 'bandera'],
};

// Función para buscar emojis por palabras clave
export function searchEmojis(query: string, emojis: string[]): string[] {
  if (!query || query.trim() === '') return emojis;

  const normalizedQuery = query.toLowerCase().trim();

  return emojis.filter((emoji) => {
    const keywords = emojiKeywords[emoji];
    if (!keywords) return false;

    return keywords.some((keyword) => keyword.includes(normalizedQuery));
  });
}
